import { useState, useEffect } from "react";
import "./App.css";
import { createBrowserRouter, RouterProvider, Outlet, Navigate } from "react-router-dom";
import { lazy, Suspense, memo } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TruckList from "./Components/TruckList";
import VehicleForm from "./Components/VehicleForm";
import store from "./redux/store";
import { Provider } from 'react-redux';
import LoginModal from "./Components/LoginModal";
import TransportReceipt from "./Components/TransportReceipt";
import HostingerExpiryModal from "./Components/HostingerExpiryModal";

// Lazy-loaded components
const HeroSection = lazy(() => import("./Components/HeroSection"));
const Header = lazy(() => import("./Components/Header"));
const Loader = lazy(() => import("./Components/Loader"));
const DriverProfile = lazy(() => import("./Components/DriverProfile"));
const Footer = lazy(() => import("./Components/Footer"));
const About = lazy(() => import("./Pages/About"));
const Contact = lazy(() => import("./Components/Contact"));
const Services = lazy(() => import("./Pages/Services"));
const FTL = lazy(() => import("./Pages/Services/FTL"));
const PTL = lazy(() => import("./Pages/Services/PTL"));
const Express = lazy(() => import("./Pages/Services/Express"));
const Warehousing = lazy(() => import("./Pages/Services/Warehousing"));
const Tracking = lazy(() => import("./Pages/Tracking"));
const Quote = lazy(() => import("./Pages/Quote"));
const Dashboard = lazy(() => import("./Components/Dashboard"));
const ProtectedRoute = lazy(() => import("./Components/ProtectedRoute"));
const RegistrationPage = lazy(() => import("./Components/RegistrationPage"));

const BackToTopButton = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    visible && (
      <button
        onClick={scrollToTop}
        className="fixed bottom-5 right-5 p-3 bg-orange-600 text-white rounded-full shadow-lg hover:bg-blue-700 transition-all duration-300"
        aria-label="Back to top"
      >

        ⬆
      </button>
    )
  );
};


const HeaderLayout = memo(({ setIsProfileModalOpen }) => (
  <>
    <Header />
    <main className="pt-[130px]">
      <Outlet />
    </main>
    <Footer />
  </>
));

function App() {
  const [loading, setLoading] = useState(true);
  const [isProfileModalOpen, setIsProfileModalOpen] = useState(false);

  const appRouter = createBrowserRouter([
    {
      path: "/",
      element: <HeaderLayout setIsProfileModalOpen={setIsProfileModalOpen} />,
      children: [
        { path: "/", element: <HeroSection /> },
        { path: "/contact", element: <Contact /> },
        { path: "/about", element: <About /> },
        { path: "/services", element: <Services /> },
        { path: "/services/ftl", element: <FTL /> },
        { path: "/services/ptl", element: <PTL /> },
        { path: "/services/express", element: <Express /> },
        { path: "/services/warehousing", element: <Warehousing /> },
        { path: "/tracking", element: <Tracking /> },
        { path: "/quote", element: <Quote /> },
        { path: "/dashboard", element: <Dashboard /> },
        { path: "/profile", element: <DriverProfile /> },
        { path: "/vehicle-registration", element: <RegistrationPage /> },
        { path: "/login", element: <LoginModal /> },
        {
          path: "/dashboard/all-trucks",
          element: (
            <ProtectedRoute>
              <TruckList />
            </ProtectedRoute>
          ),
        },
        {
          path: "/dashboard/add-trucks",
          element: (
            <ProtectedRoute>
              <VehicleForm />
            </ProtectedRoute>
          ),
        },
        {
          path: "/dashboard/add-receipt",
          element: (
            <ProtectedRoute>
              <TransportReceipt />
            </ProtectedRoute>
          ),
        },
        {
          path: "/transport-receipts",
          element: (
            <ProtectedRoute>
              <TransportReceipt />
            </ProtectedRoute>
          ),
        },
      ],
    },
  ]);

  return (
    <Provider store={store}>
      <Suspense fallback={<Loader />}>
{/*<HostingerExpiryModal />*/}
        <RouterProvider router={appRouter} />

        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
        <BackToTopButton />
      </Suspense>
    </Provider>
  );
}

export default App;
